/**
 * Plain words for asking an item's author (epic PI-SPEC-SW-E292, feature
 * PI-SPEC-SW-1498, UX-PM-06, frames D3 and D4): the short date, how long ago,
 * how often and whose first name. Pure; shared by the questions card and the
 * reading pane's below-bar line.
 */
import { daysAgoWords } from "@/lib/grooming/next-step";

const MONTH_DAY = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });

/** "Oct 14" for an ISO date, or null when it does not parse. */
export function shortDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : MONTH_DAY.format(date);
}

/** "today", "yesterday" or "6 days ago", counted in local calendar days: the Backlog's own words. */
export function relativeDays(iso: string, now: Date = new Date()): string {
  return daysAgoWords(iso, now);
}

/** "asked twice", "asked 3 times"; null for a single ask. */
export function askCountWords(count: number): string | null {
  if (count <= 1) return null;
  if (count === 2) return "asked twice";
  return `asked ${String(count)} times`;
}

/** The first word of a display name ("Maria" for "Maria Lopez"), or "the author". */
export function firstName(name: string | null | undefined): string {
  const first = name?.trim().split(/\s+/)[0];
  return first && first.length > 0 ? first : "the author";
}
